/**
 * TextField
 */
import React, { useState } from 'react';
import { default as MuiTextField } from '@material-ui/core/TextField';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useFormContext, useSize } from '../..';
import TextFieldAdornment from '../TextFieldAdornment';
const backgroundViaProp = ({ palette }) => ({ background }) => background === 'light' ? palette.background.paper : undefined;
const useInputStyles = makeStyles(({ spacing, palette }) => createStyles({
    inputMarginDense: {
        padding: `${spacing(0.5, 0.5)} !important`,
    },
    root: {
        padding: ({ size }) => (size === 'medium' ? undefined : 0),
        paddingRight: ({ size }) => (size === 'medium' ? undefined : spacing(3)),
        backgroundColor: backgroundViaProp({ palette }),
        '&:hover:not(.Mui-disabled)': {
            backgroundColor: backgroundViaProp({ palette }),
        },
        '&.Mui-focused': {
            backgroundColor: backgroundViaProp({ palette }),
        },
    },
}));
const useInputLabelStyles = makeStyles(() => createStyles({
    root: ({ size }) => (size === 'medium' ? {} : { display: 'none' }),
}));
export const Text = props => {
    const { onClear, variant = 'filled', validateFirst, size, InputProps, InputLabelProps, ...rest } = props;
    const { size: contextSize } = useSize();
    const realSize = contextSize || size || 'medium';
    const inputClasses = useInputStyles({ ...props, size: realSize });
    const inputLabelClasses = useInputLabelStyles({ ...props, size: realSize });
    // touched is used to display adornments after an input has been focused
    // or when specified to validateFirst
    const [touched, setTouched] = useState(!!validateFirst);
    const useValidationIcon = useFormContext().useValidationIcon;
    const onFocus = (e) => {
        rest.onFocus && rest.onFocus(e);
        useValidationIcon && setTouched(true);
    };
    const adornmentProps = {
        error: props.error,
        onClear,
        value: props.value,
    };
    const inputClassOverrides = InputProps ? InputProps.classes : {};
    const inputLabelClassOverrides = InputLabelProps ? InputLabelProps.classes : {};
    return (React.createElement(MuiTextField, Object.assign({ fullWidth: true, variant: variant, margin: realSize === 'medium' ? 'none' : 'dense', error: validateFirst ? rest.error : touched && rest.error, InputProps: {
            endAdornment: touched && React.createElement(TextFieldAdornment, Object.assign({}, adornmentProps)),
            onFocus,
            ...InputProps,
            classes: { ...inputClasses, ...inputClassOverrides },
        }, InputLabelProps: {
            ...InputLabelProps,
            classes: { ...inputLabelClasses, ...inputLabelClassOverrides },
        } }, rest)));
};
//# sourceMappingURL=Text.js.map